// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Fade__wrapper___K8PUL","enter":"Fade__enter___2hQq4","enterActive":"Fade__enterActive___3rRlM","leave":"Fade__leave___2BTTc","leaveActive":"Fade__leaveActive___cT9df"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Transitions/Fade.scss
// module id = 565
// module chunks = 0